import { useSidebar } from "../../components/ui/sidebar";
import { ChevronLeft, ChevronRight } from "lucide-react";

type Props = {
  sidebarOpen: boolean;
  toggle: (togle: boolean) => void;
};

const CustomTrigger = ({ sidebarOpen, toggle }: Props) => {
  const { open, toggleSidebar } = useSidebar();

  return (
    <button
      onClick={() => {
        toggle(!sidebarOpen);
        toggleSidebar();
      }}
      aria-label="Toggle sidebar"
      className={`
        flex items-center justify-center
        h-9 w-9 rounded-full
        transition-all duration-300 ease-in-out
        border
        hover:cursor-pointer
        ${
          open
            ? "text-brand-text hover:bg-brand-sidebar hover:text-brand-cardtext"
            : "bg-brand-sidebar text-brand-cardtext border-brand-sidebar hover:bg-brand-card hover:text-brand-text"
        }
      `}
    >
      <span
        className={`
          transition-transform duration-300 ease-in-out
          ${open ? "rotate-0" : "rotate-0"}
        `}
      >
        {open ? <ChevronLeft /> : <ChevronRight />}
      </span>
    </button>
  );
};

export default CustomTrigger;
